import { darken, lighten } from 'polished';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import backgroungImg from 'assets/sun-tornado.svg';
import { COLORS } from 'styles/constants';

export const Container = styled.div`
  padding: 30px 0;
  width: 100%;
  min-height: 81vh;

  color: #fff;
  background: url(${backgroungImg}) no-repeat center;
  background-size: cover;
  font-size: 2.7vh;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h2 {
    font-size: 2.7vh;
    width: 50%;
    margin-bottom: 30px;
    display: flex;
    flex-direction: row;
    align-items: center;

    svg {
      cursor: pointer;
    }

    svg:hover {
      color: ${COLORS.darkBackground};
    }
  }

  h2:before,
  h2:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid;
    margin: auto;
  }
  h2:before {
    margin-right: 10px;
  }
  h2:after {
    margin-left: 10px;
  }

  @media only screen and (max-width: 700px) {
    h2 {
      width: 80%;
    }
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    h2 {
      width: 80%;
    }
  }

  @media only screen and (min-width: 1400px) {
    min-height: 86vh;
  }
`;

export const ServiceInfo = styled.div`
  margin: 25px;
  position: relative;

  display: flex;
  flex-direction: column;
  align-items: center;

  h3 {
    margin-top: 20px;
    text-align: center;
  }

  h5 {
    margin-top: 5px;
    text-align: center;
  }

  p {
    margin-top: 30px;

    font-size: 16px;
    text-align: center;
  }
`;

export const EditServiceButton = styled.button`
  position: absolute;
  top: -18px;
  left: 0px;
  padding: 10px;

  border: none;
  border-radius: 50%;
  background: #fff;

  transition: background 0.2s;

  display: flex;

  svg {
    color: ${COLORS.primary};
  }

  &:hover {
    background: ${COLORS.darkBackground};
  }
`;

export const DeleteServiceButton = styled.button`
  position: absolute;
  top: -18px;
  right: 0px;
  padding: 10px;

  border: none;
  border-radius: 50%;
  background: #fff;

  transition: background 0.2s;

  display: flex;

  svg {
    color: ${COLORS.primary};
  }

  &:hover {
    background: ${COLORS.darkBackground};
  }
`;

export const ContactInfo = styled.div`
  width: 100%;

  display: flex;
`;

export const CategoryImages = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 20px;
  }
`;

export const InstagramBox = styled(Link)`
  margin: 7px 0 10px 0;
  padding: 8px;

  background: #fff;
  border-radius: 5px;
  text-decoration: none;
  color: ${COLORS.primary};

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LocationContainer = styled.div`
  margin-top: 20px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  h5 {
    margin: 0;
  }
`;

export const ActionButton = styled.button`
  width: 24%;
  margin-bottom: 30px;
  padding: 14px 16px;

  color: ${lighten(0.22, COLORS.darkBackground)};
  text-align: left;
  font-size: 21px;
  background: #fff;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  border: none;
  border-radius: 5px;
  transition: background 0.1s;

  display: flex;
  justify-content: center;
  align-items: center;

  b {
    color: ${COLORS.primary};
  }

  p {
    margin-right: 25px;
    font-size: 18px;
  }

  svg {
    color: ${COLORS.primary};
  }

  @media only screen and (max-width: 700px) {
    width: 80%;
    font-size: 20px;
  }

  @media all and (min-width: 600px) and (max-width: 1200px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    font-size: 25px;
    width: 76%;
  }

  &:hover {
    background: ${darken(0.03, '#fff')} !important;
  }
`;
